import store from "../store";
/**
 * 单点登录
 */
const init = (callback) => {
  console.log("-------单点登录开始-------");
  let token = window.localStorage.getItem("token");
  let st = getUrlParam("ticket");
  let sevice = "http://" + window.location.host + "/";
  if (st) {
    // 拿到 ticket 后立刻清掉 URL 上的 ticket 参数，防止：
    // 1. 后续跳转时 redirect URL 把失效 ticket 带到 SSO Server 导致 URL 累积死循环
    // 2. 用户刷新页面时重复用同一个（已被消费的）ticket 触发校验失败
    let cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);
    validateSt(st, sevice, callback);
  } else {
    callback();
    // let redirect = encodeURIComponent(sevice);
    // window.location.href = `${process.env.VUE_APP_CAS_BASE_URL}?redirect=${redirect}`;
  }
  // if (token) {
  //   callback();
  // } else {
  //   if (st) {
  //     validateSt(st, sevice, callback);
  //   } else {
  //     let redirect = encodeURIComponent(sevice);
  //     window.location.href = `${process.env.VUE_APP_CAS_BASE_URL}?redirect=${redirect}`;
  //   }
  // }
  console.log("-------单点登录结束-------");
};

const SSO = {
  init: init,
};

function getUrlParam(paraName) {
  let url = document.location.toString();
  let arrObj = url.split("?");

  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split("&");
    let arr;
    let lastValue = "";

    // 遍历取最后一个匹配项（防御性：SSO Server 跳回时若 URL 累积了多个 ticket，
    // 最新颁发的 ticket 总是在 URL 末尾）
    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] == paraName) {
        lastValue = arr[1];
      }
    }
    return lastValue;
  } else {
    return "";
  }
}

function validateSt(ticket, service, callback) {
  let params = {
    ticket: ticket,
    service: service,
  };
  store
    .dispatch("login", params)
    .then((res) => {
      //this.departConfirm(res)
      if (res.success) {
        callback();
      } else {
        // let sevice = "http://" + window.location.host + "/";
        // let serviceUrl = encodeURIComponent(sevice);
        // window.location.href =
        //   window._CONFIG["casPrefixUrl"] + "/login?service=" + serviceUrl;
      }
    })
    .catch((err) => {
      console.log(err);
      //that.requestFailed(err);
    });
}

export default SSO;
